/**
 * useLpScroll이 전제하는 마크업 선택자와 동작 튜닝 값.
 * 마크업 구조는 같은 폴더의 README.md 참고.
 */

/** 훅이 찾는 요소들 */
export const SELECTOR = {
  header: '#header', // 고정 헤더
  wrap: '.bottom-product-wrap', // 상태 클래스가 붙는 래퍼
  seat: '.area-menu', // 고정 중 흐름에 남아 자리를 지키는 껍데기
  inner: '.inner-area-menu', // 실제로 고정되는 탭 묶음
  row: '.category-menubar', // 뎁스 한 줄
  filterBar: '.lp-filter-bar',
  quick: '.area-quick', // 고정되지 않는 퀵 필터 줄
  pin: '.pin-area', // 탭 아래에 sticky로 붙는 필터 바
  sorting: '.sorting-bar',
  list: '.product-list',
  input: '.input-box', // 검색 인풋
} as const;

/** 고정 헤더(#header) 높이(px) */
export const HEADER_HEIGHT = 50;

/* 탭 고정·접힘 ------------------------------------------------------- */

/** 반대 방향으로 이만큼(px) 움직여야 방향 전환으로 본다 */
export const TURN_THRESHOLD = 48;
/** 껍데기 높이를 바꾼 뒤 브라우저의 보정 스크롤을 무시하는 시간(ms) */
export const ANCHOR_HOLD = 150;

/* 최상단 이동 -------------------------------------------------------- */

/** 스크롤 요청이 먹었는지 확인하는 간격(ms)과 재시도 횟수 */
export const SCROLL_RETRY_GAP = 250;
export const SCROLL_RETRY_MAX = 2;

/* 하위 뎁스 노출 ----------------------------------------------------- */

/** 노출을 앞당기는 시간의 하한(ms). 실측한 리렌더 시간이 더 크면 그 값을 쓴다 */
export const DEPTH_REVEAL_LEAD = 120;
/** 남은 이동 시간을 추정하기 전에 확보할 최소 관측 시간(ms) */
export const DEPTH_REVEAL_SAMPLE = 48;
/** 스크롤 이동 완료를 기다리는 최대 시간(ms) */
export const DEPTH_REVEAL_MAX_WAIT = 1200;

/** 등장 모션의 최소 길이(ms) */
export const DEPTH_IN_MIN_DURATION = 140;
/** 밀려난 거리(px)가 이보다 작으면 등장 모션을 생략한다 */
export const DEPTH_IN_MIN_SHIFT = 2;
/** LpScrollStyle의 --depth-in-* 을 읽지 못했을 때의 기본값 */
export const DEPTH_IN_FALLBACK = { duration: 300, easing: 'ease-out' };

/* 검색 인풋 포커스 --------------------------------------------------- */

/** 키보드가 올라오길 기다리는 시간(ms) */
export const KEYBOARD_DELAY = 100;
